import React from "react";
import style from "./CheckBox.module.css"

function CheckBox(props) {

    const sessioneUtente = sessionStorage.getItem("sessioneUtente")?JSON.parse(sessionStorage.getItem("sessioneUtente")):{}

    return (
        <div className={'form-check '.concat(!sessioneUtente || (sessioneUtente && sessioneUtente.tipoUtente === "03")?style.formCheckCustom:"")}>
            <input
                type={"checkbox"}
                id={props.id}
                onChange={props.onChange}
                checked={props.checked}
                disabled={props.disabled}
            />
            <label htmlFor={props.id ? props.id : 'checkbox1'}>
                <span className={props.classNameText ? props.classNameText : null}>
                    {props.text}
                </span>
                {props.obbligatorio && <span className={"obbligatorietaColor"}>*</span>}
            </label>
        </div>
    )
}
export default CheckBox
